document.addEventListener('DOMContentLoaded', function () {
  if (window.screen.width < 800) {
    // ----- MENU -----
    var menu = document.querySelector('.main_nav .show_menu');
    var closeMenu = document.querySelector('.main_nav .close_menu');
    var menuForm = document.querySelector('.modal_parent');
    menu.addEventListener('click', openMenu);
    closeMenu.addEventListener('click', closemenu);
    function openMenu() {
      menuForm.classList.add('is_active');
      menu.classList.add('hidden_button');
      closeMenu.classList.add('visible_button');
    }
    function closemenu() {
      menuForm.classList.remove('is_active');
      menu.classList.remove('hidden_button');
      closeMenu.classList.remove('visible_button');
    }
    menuForm.addEventListener('click', function (event) {
      if (!event.target.closest('.inner')) {
        closemenu();
      }
    });
    // ----- END OF MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function (i) {
      i.addEventListener('click', toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        var submenu = this.parentNode.children[2];
        if (submenu.classList.contains("submenu_show")) {
          submenu.classList.remove("submenu_show");
          this.classList.remove("active_svg");
        } else {
          submenu.classList.add("submenu_show");
          this.classList.add("active_svg");
        }
      }
    });
  }
  //----- SEARCH -----
  var searchIcon = document.querySelector(".main_header .search .search_icon");
  var closeSearch = document.querySelector(".main_header .search .close_search");
  var searchForm = document.querySelector(".main_header .search .search_parent");
  var searchInput = document.querySelector(".main_header .search .search_input");
  if (searchIcon && searchForm) {
    searchIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      searchForm.classList.add("visible");
      searchIcon.classList.add("hidden_button");
      closeSearch.classList.add("visible_button");
      searchInput.focus();
    });
    closeSearch.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearchFunc();
    });
    searchForm.addEventListener("click", function (e) {
      if (!searchIcon.contains(e.target) && !searchInput.contains(e.target)) {
        closeSearchFunc();
      }
    });
  }
  function closeSearchFunc() {
    searchForm.classList.remove("visible");
    searchIcon.classList.remove("hidden_button");
    closeSearch.classList.remove("visible_button");
  }
  // ----- ADDED POSITION FIXED TO MODAL_PARENT & SEARCH_PARENT ----- //
  function handleScrollModalTop() {
    const header = document.querySelector('.main_header');
    const modal = document.querySelector('.modal_parent');
    const modalSearchList = document.querySelectorAll('.search_parent');
    if (!header || !modal) return;
    const headerHeight = header.offsetHeight;
    if (window.scrollY >= headerHeight) {
      modal.classList.add('scrolled');
      modalSearchList.forEach(function (search) {
        if (search.classList.contains('visible')) {
          search.classList.add('scrolled');
        }
      });
    } else {
      modal.classList.remove('scrolled');
      modalSearchList.forEach(function (search) {
        search.classList.remove('scrolled');
      });
    }
  }
  handleScrollModalTop();
  window.addEventListener('scroll', handleScrollModalTop);
  window.addEventListener('resize', handleScrollModalTop);
  // ----- END OF MODAL_PARENT & SEARCH_PARENT ----- //
  // ---- LIGHTGALLERY ---- //
  if (document.querySelectorAll('.album_list')) {
    var gallery = document.querySelectorAll(".album_list");
    gallery.forEach(function (pic) {
      lightGallery(pic, {
        speed: 500,
        plugins: [lgThumbnail],
        thumbnail: true
      });
    });
  }
  // ---- TABLE ---- //
  if (document.querySelector(".ck_editor")) {
    var tables = document.querySelectorAll(".ck_editor table");
    tables.forEach(function (table) {
      var parentTable = document.createElement('div');
      parentTable.classList.add("table_res");
      table.parentNode.replaceChild(parentTable, table);
      parentTable.appendChild(table);
    });
  }
  // ---- SHORT_LINK ---- //
  if (document.querySelector(".short_link")) {
    var shortLink = document.querySelector(".short_link");
    if (shortLink) {
      shortLink.addEventListener("click", function (event) {
        event.preventDefault();
        var temp = document.getElementById("short_link_copy");
        temp.select();
        document.execCommand("copy");
        document.querySelector(".copied").style.display = "flex";
        setTimeout(function () {
          document.querySelector(".copied").style.display = "none";
        }, 3000);
      });
    }
  }
  // ---- START OF COMMENT NEWS AJAX ----
  const isRTL = document.documentElement.dir === "rtl";
  function convertToPersianNumbers(input) {
    if (!input) return ""; // If input is falsy (like 0), return an empty string
    const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return String(input).replace(/\d/g, (digit) => persianDigits[digit]);
  }
  if (document.getElementById('comment_list_ajax')) {
    const commentList = document.getElementById('comment_list_ajax');
    const loadMoreBtn = document.getElementById('load_more_comment');
    let currentPage = 1;
    // Initialize limit comment number
    const limitPage = 5;

    if (news_comment < limitPage) loadMoreBtn.remove();

    const loadMoreComments = () => {
      fetch(`/comments/ajaxCommentList?newsId=${news_id}&page=${currentPage}&limit=${limitPage}`)
        .then(response => response.json())
        .then(data => {
          if (!data || data.length < limitPage) loadMoreBtn.style.display = 'none';
          if (data) {
            data.forEach(comment => {
              const renderChildren = children => children ? `<ul>${children.map(child => `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">
                  <p class="user_name">
                    ${child.name || window.i18n.commentUnknown}
                  </p>
                  <span class="comment_published">
                    <svg aria-hidden="true"xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="12" height="12" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1536 1536"><path fill="#e4378d" d="M896 416v448q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224V416q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198t-273-73t-273 73t-198 198t-73 273t73 273t198 198t273 73t273-73t198-198t73-273zm224 0q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768z"></path></svg>
                    <time datetime="${child.creation}">${isRTL ? convertToPersianNumbers(child.date) : child.date}</time>
                  </span>
                  </div>
                  <div class="comment_reply">
                    <button aria-label="like" onclick="Rate.plus(${child.master_id})" class="like">
                      <span id="rateplus${child.master_id}">
                      ${child.plus !== null ? (isRTL ? convertToPersianNumbers(child.plus) : child.plus) : (isRTL ? "۰" : "0")}
                      </span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7c0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4c47.6-20.3 78.3-66.8 78.3-118.4c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="dislike" onclick="Rate.minus(${child.master_id})" class="dislike">
                      <span id="rateminus${child.master_id}">
                      ${child.minus !== null ? (isRTL ? convertToPersianNumbers(child.minus) : child.minus) : (isRTL ? "۰" : "0")}
                      </span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4c20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3c40.4-23.5 65.5-66.1 65.5-111c0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${child.message}</p>
                </div>
              </li>`).join('')}</ul>` : '';

              commentList.innerHTML += `
              <li>
                <div class="comment_list_header">
                  <div class="comment_list_user">
                  <p class="user_name">
                  ${comment.name || window.i18n.commentUnknown}
                  </p>
                  <span class="comment_published">
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="12" height="12" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1536 1536"><path fill="#e4378d" d="M896 416v448q0 14-9 23t-23 9H544q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224V416q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198t-273-73t-273 73t-198 198t-73 273t73 273t198 198t273 73t273-73t198-198t73-273zm224 0q0 209-103 385.5T1153.5 1433T768 1536t-385.5-103T103 1153.5T0 768t103-385.5T382.5 103T768 0t385.5 103T1433 382.5T1536 768z"></path></svg>
                    <time datetime="${comment.creation}">${isRTL ? convertToPersianNumbers(comment.date) : comment.date}</time>
                  </span>
                  </div>
                  <div class="comment_reply">
                    <button aria-label="like" onclick="Rate.plus(${comment.master_id})" class="like">
                      <span id="rateplus${comment.master_id}">
                      ${comment.plus !== null ? (isRTL ? convertToPersianNumbers(comment.plus) : comment.plus) : (isRTL ? "۰" : "0")}
                      </span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7c0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4c47.6-20.3 78.3-66.8 78.3-118.4c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c0-12.6-1.8-25-5.4-37c16.8-22.2 26.1-49.4 26.1-77.7c-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="dislike" onclick="Rate.minus(${comment.master_id})" class="dislike">
                      <span id="rateminus${comment.master_id}">
                      ${comment.minus !== null ? (isRTL ? convertToPersianNumbers(comment.minus) : comment.minus) : (isRTL ? "۰" : "0")}
                      </span>
                      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" role="img" width="14" height="14" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024"><path d="M885.9 490.3c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-28.3-9.3-55.5-26.1-77.7c3.6-12 5.4-24.4 5.4-37c0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4c20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3c40.4-23.5 65.5-66.1 65.5-111c0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"/></svg>
                    </button>
                    <button aria-label="replay" onclick="setCommentParentId(${comment.id})" class="reply">${window.i18n.commentReply}</button>
                  </div>
                </div>
                <div class="matn_comment">
                  <p>${comment.message}</p>
                  ${comment.children === null || comment.children.length === 0 ? '' : renderChildren(comment.children)}
                </div>
              </li>`;
            });
            currentPage++;
          }
        })
        .catch(error => console.error(error));
    };

    loadMoreComments();
    loadMoreBtn.addEventListener('click', loadMoreComments);
  }
  // ----- INLINE BOXS & ADV -----
  var countP = document.querySelectorAll('.ck_editor p:not(table p, blockquote p)');

  function insertBefore(newNode, dist) {
    dist.parentNode.insertBefore(newNode, dist)
  }
  // *-*-*-*-*-*- AFTER P-2 -*-*-*-*-*-*- //
  if (document.getElementById('position_G4')) {
    if (countP.length > 1) {
      var adv = document.getElementById('position_G4');
      insertBefore(adv, countP[1].nextSibling);
    } else {
      document.getElementById('position_G4').style.display = "none";
    }
  }
  // *-*-*-*-*-*- AFTER P-4 -*-*-*-*-*-*- //
  if (document.getElementById('position_G5')) {
    if (countP.length > 3) {
      var adv = document.getElementById('position_G5');
      insertBefore(adv, countP[3].nextSibling);
    } else {
      document.getElementById('position_G5').style.display = "none";
    }
  }
  // *-*-*-*-*-*- AFTER P-6 -*-*-*-*-*-*- //
  if (document.getElementById('position_G6')) {
    if (countP.length > 5) {
      var adv = document.getElementById('position_G6');
      insertBefore(adv, countP[5].nextSibling);
    } else {
      document.getElementById('position_G6').style.display = "none";
    }
  }
  // *-*-*-*-*-*- AFTER P-8 -*-*-*-*-*-*- //
  if (document.getElementById('position_G7')) {
    if (countP.length > 7) {
      var adv = document.getElementById('position_G7');
      insertBefore(adv, countP[7].nextSibling);
    } else {
      document.getElementById('position_G7').style.display = "none";
    }
  }
})